import Error, { EErrorType } from "./Error";

export { EErrorType };
export default Error;
